"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DYNAMIC_RANKING_CONSTANT = void 0;
// segmentCriteria is combination of Number of night, Number of pax, Number of rooms
// 1_2_1 -- 1 Night stay, 2 Guests, 1 room
var DYNAMIC_RANKING_CONSTANT = exports.DYNAMIC_RANKING_CONSTANT = [{
  segmentId: 1,
  segmentCriteria: '1_2_1'
}, {
  segmentId: 2,
  segmentCriteria: '3_2_1'
}, {
  segmentId: 3,
  segmentCriteria: '2_2_1'
}, {
  segmentId: 4,
  segmentCriteria: '4_2_1'
}, {
  segmentId: 5,
  segmentCriteria: '5_2_1'
}, {
  segmentId: 6,
  segmentCriteria: '1_1_1'
}, {
  segmentId: 7,
  segmentCriteria: '2_1_1'
}, {
  segmentId: 8,
  segmentCriteria: '6_2_1'
}, {
  segmentId: 9,
  segmentCriteria: '3_1_1'
}, {
  segmentId: 10,
  segmentCriteria: '7_2_1'
}];